import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithFtp_1 from '../../../../../libraries/Images/createAConnectionWithFtp_1.png';
import createAConnectionWithFtp_2 from '../../../../../libraries/Images/createAConnectionWithFtp_2.png';
import createAConnectionWithFtp_3 from '../../../../../libraries/Images/createAConnectionWithFtp_3.png';
import createAConnectionWithFtp_4 from '../../../../../libraries/Images/createAConnectionWithFtp_4.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithawss3">
                1.&nbsp;{translate('createaconnectionwithawss3')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "FTP" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_2} width="75%" />
            </Zoom>
            <p>Sau khi bạn nhấp vào "FTP", vui lòng nhập các giá trị cần thiết rồi nhấp nút OK để hoàn tất.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ FTP sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_4} width="50%" />
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong FTP.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);